import { IS_PROD_BUILD } from '@src/config/env'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { useCallback, useState } from 'react'
import { getOptionsWithBearerToken } from '../utils'

const useBearerFetch = (parseJson = true) => {
  const [response, setResponse] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(
    async (url, options) => {
      setLoading(true)
      const bearerOptions = await getOptionsWithBearerToken(options)

      try {
        const res = await fetch(url, bearerOptions)

        if (!res.ok) {
          const isUnauthRes = res.status === 401 || res.status === 403
          if (IS_PROD_BUILD && isUnauthRes && isBrowser()) {
            await window.logoutUser(false, true)
          }
          let errorBody
          try {
            errorBody = parseJson ? await res.json() : await res.text()
          } catch (parseError) {
            console.error('Error parsing response body:', parseError)
            errorBody = null
          }
          const error = new Error(
            `Error fetching data for url:: ${url} with status:: ${res.status}. useBearerFetch() hook runtime error`,
          )
          error.responseBody = errorBody
          error.status = res.status
          setError(error)
          setLoading(false)
        } else {
          let data
          if (parseJson) {
            data = await res.json()
          } else {
            data = await res.text()
          }
          setLoading(false)
          setResponse(data)
        }
      } catch (err) {
        setError(err)
        setLoading(false)
      }
    },
    [parseJson],
  )

  return { fetchData, response, error, loading }
}

export default useBearerFetch
